'use client';

import { useAccountUm } from '@/hooks/use-account-um';
import { useBrazeUserProfile } from '@/hooks/use-braze-user-profile';
import { useHeaderVisible } from '@/hooks/use-header-visible';
import { useInitUserContext } from '@/hooks/use-init-user-context';
import { useIsSearchOpen } from '@/hooks/use-is-search-open';
import { useMessageListener } from '@/hooks/use-message-listener';
import { useNavigationChange } from '@/hooks/use-navigation-change';
import type { UserContext } from '@/types/user-context';
import type { SiteWideJackpotData } from '@/types/aggregation/site-wide-jackpot';
import { useIsPopupOpen } from '../use-is-popup-open';
import { useJackpotFeed } from '@/app/components/site-wide-jackpot/hooks/use-jackpot-feed';
import { useMdsConsumer } from '@/app/components/site-wide-jackpot/hooks/use-mds-consumer';
import { useBiggestWinPopup } from '../use-biggest-win-popup';
import type { ServerContext } from '@/store/server-context';
import { useSearchMl } from '@/hooks/use-search-ml';
import { usePokerSessionRefresh } from '@/hooks/use-poker-session-refresh';
import { useInProgressGameRecovery } from '@/app/components/embedded-game-shell/hooks/useInProgressGameRecovery';
import { useNotificationsUm } from '@/hooks/use-notifications-um';

type InitProps = {
    userContextResponse: UserContext | null;
    siteWideJackpot: SiteWideJackpotData;
    serverContext: ServerContext;
};

export const useInitPage = ({ userContextResponse, siteWideJackpot, serverContext }: InitProps) => {
    useInProgressGameRecovery();
    useSearchMl(serverContext.experiments);
    useInitUserContext(userContextResponse);
    useBrazeUserProfile();
    useAccountUm();
    useNotificationsUm(serverContext.featureFlags);
    usePokerSessionRefresh();
    useMessageListener(); // TODO: investigate, this already uses account um
    useNavigationChange();
    useIsSearchOpen();
    useHeaderVisible();
    useIsPopupOpen();
    useJackpotFeed(siteWideJackpot);
    useMdsConsumer(siteWideJackpot);
    useBiggestWinPopup();
};
